class BadgeCustom extends HTMLElement {
  connectedCallback() {
    this.innerHTML = window.badgeCustom;

    const text = this.attributes.getNamedItem("text")?.value || "";
    const color = this.attributes.getNamedItem("color")?.value || "badge--black";

    this.querySelector(".badge-text")!.innerHTML = text;
    this.querySelector(".badge")!.classList.add(`badge--${color}`);
  }
}

customElements.define("badge-custom", BadgeCustom);
